<script>
  import { getAccessibilityRedesignRenderState } from '../../../../../js/stores';
  import SpotlightItem from './SpotlightItem/SpotlightItem.svelte';

  // Props
  export let id = '';
  export let title = '';
  export let items = [];

  const accessibilityRedesignRenderStore = getAccessibilityRedesignRenderState();
</script>

<div
  {id}
  class="Spotlight"
  class:spotlight-accessibility-redesign={$accessibilityRedesignRenderStore}
  data-subcategory={title}
>
  <div class="spotlight-container">
    <span class="spotlight-title" role="heading" aria-level="2">{title}</span>
    {#if items}
      {#each items as item}
        <SpotlightItem
          id={item.id}
          image={item.image}
          url={item.url}
          linkText={item.linkText}
          description={item.description}
        />
      {/each}
    {/if}
  </div>
</div>

<style>@charset "UTF-8";
.Spotlight {
  margin-right: 32px;
  border-left: 1px solid var(--color-border, #d9d9d9);
}

.spotlight-accessibility-redesign {
  border: none;
}

.spotlight-container {
  margin-left: 32px;
}

.spotlight-title {
  font-weight: var(--font-weight-medium, 500);
  text-transform: uppercase;
  letter-spacing: 0.125em;
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 14px;
  line-height: 22px;
  display: block;
  width: max-content;
  margin-bottom: 32px;
  color: var(--color-gray, #737373);
}</style>
